"use client";

import React, { useState } from 'react';
import { NewsletterJoinForm } from '@/components/forms/newsletter-join';


const Newsletter: React.FC = () => {
    return (
        <section id="newsletter" className="bg-white py-16 md:py-20">
            <div className="container mx-auto px-6">
                <div className="mx-auto mb-12">
                    <p className="text-sky-700 font-semibold uppercase tracking-wider mb-4 text-sm border-l-3 border-sky-700 pl-3 text-left">
                        Newsletter
                    </p>
                </div>

                <div className="max-w-3xl mx-auto ">
                    <NewsletterJoinForm />
                </div>
            </div>
        </section>
    );
};

export default Newsletter;
